import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import {
  State,
  SocialLinksResponse,
  UpdateSocialLinkRequest,
  BulkUpdateSocialLinksRequest,
} from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {
  socialLinks: [],
  floatingSocialLinks: [],
  popularPlatforms: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'socialLinks',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
  },
});

export const api = createApi({
  reducerPath: 'socialLinksApi',
  baseQuery,
  tagTypes: ['socialLinks'],
  endpoints: builder => ({
    // Get all social links with pagination
    getSocialLinks: builder.query<SocialLinksResponse, void>({
      query: () => ({
        url: endpoints.SOCIAL_LINKS,
        method: 'GET',
      }),
      providesTags: ['socialLinks'],
    }),

    // Update a social link
    updateSocialLink: builder.mutation<any, any>({
      query: data => ({
        url: `${endpoints.SOCIAL_LINKS}/update`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['socialLinks'],
    }),
  }),
});

export const { actions: socialLinksActions } = slice;

export const useSocialLinksSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: socialLinksActions,
    // Queries
    useGetSocialLinksQuery: api.useLazyGetSocialLinksQuery,
    useUpdateSocialLinkMutation: api.useUpdateSocialLinkMutation,
  };
};
